import type { TarotCard, TarotCardDetail } from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type { TarotCard, TarotCardDetail };

export async function getDailyTarot(rashi?: string): Promise<TarotCard> {
  const path = rashi ? `/tarot/daily/${rashi}` : `/tarot/daily`;
  return apiRequest<TarotCard>(path);
}

export async function drawTarotCards(count = 1, question?: string): Promise<TarotCard[]> {
  return apiRequest<TarotCard[]>("/tarot/draw", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ count, question: question || null }),
  });
}

export async function getTarotCard(cardId: number): Promise<TarotCardDetail> {
  return apiRequest<TarotCardDetail>(`/tarot/card/${cardId}`);
}

export async function getAllTarotCards(): Promise<TarotCardDetail[]> {
  return apiRequest<TarotCardDetail[]>("/tarot/cards");
}
